import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useRef, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ProvidersSwiper from "../Games/ProvidersSwiper";
import PageBanner from "../PageBanner";
import ProvidersMobileSwiper from "../Games/ProvidersMobileSwiper";
import GridContainer from "../Games/GridContainer";
import { MdOutlineCasino } from "react-icons/md";
import { PiCoinsBold } from "react-icons/pi";
import FilterSearch from "../Games/FilterSearch";
import FilterTypes from "../Games/FilterTypes";
import PragmaticGameBox from "../GamerBoxes/PragmaticGameBox";
import SmartSoftGameBox from "../GamerBoxes/SmartSoftGameBox";
import BLAS975GameBox from "../GamerBoxes/BLAS975GameBox";
import { useParams } from "react-router-dom";
import BannerCarouselV2 from "../Home/BannerCarouselV2";
import BottomNavigation from "../BottomNavigation";
import Footer from "../Home/Footer";
import NoGamesFound from "./NoGamesFound";
import MatGameBox from "../GamerBoxes/MatGameBox";
import InnovaBox from "../GamerBoxes/InnovaBox";
import { SiteFeatures } from "config/siteFeatures";
import GaseaBox from "../GamerBoxes/GaseaBox";
import { createPermissionKey } from "BaseServiceURLs";
import BannerCarousel from "../Home/BannerCarousel";
import BannerCarouselV3 from "../Home/BannerCarouselV3";

const ScrollableListView = (props) => {
  const {
    user,
    loggedIn,
    sports,
    games,
    UpdateSport,
    data,
    pb,
    provider,
    setProvider,
    title,
    children,
    FilterSearchValue,
    setFilterSearchValue,
    selectedProviders,
    setSelectedProviders,


  } = props;
  const [loading, setLoading] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isNavVisible, setIsNavVisible] = useState(true);

  const [visibleData, setVisibleData] = useState([]);
  const containerRef = useRef(null);

  const [currentProvider, setCurrentProvider] = useState(null);
  const [activeFilterButton, setActiveFilterButton] = useState(0); // 0 = hiçbiri, 1 = buton1, 2 = buton2

  let params = GetParams();

  function GetParams() {
    let params = useParams();
    return params;
  }

  const adjustHeight = () => {
    try {
      const navbarHeight = document.querySelector(".base-nav")?.offsetHeight;
      const navbarHeight1 = document.querySelector(".base-nav1")?.offsetHeight;
      const windowHeight = window.innerHeight;

      if (containerRef && containerRef.current) {
        const h =
          windowHeight -
          (navbarHeight > navbarHeight1 ? navbarHeight : navbarHeight1);
        containerRef.current.style.height = `${h}px`;
      }
    } catch (error) { }
  };

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", adjustHeight);
    window.addEventListener("resize", adjustHeight);
    /*
     const _group = props.data.reduce((a, v) => ((a[v._middleware === "innova" ? `${v.vendor}_innova` : v.vendor] ??= []).push(v), a), {})
     let _pp = {};
     const _ex = Object.keys(_group).map(x => {
       _pp[x] = `${_group[x][0]._midleware.toUpperCase()}_${x.toUpperCase()}_GAMES_ACCESS`
       return ({
         "AllowToChilds": true,
         "Type": "bool",
         "SettingName": `${_group[x][0]._midleware.toUpperCase()}_${x.toUpperCase()}_GAMES_ACCESS`,
         "DefaultValue": "true",
         "Category": "PROVIDERS",
         "SettingsID": 1,
         "Value": true
       })
     })
     debugger
    */
  }, []);

  // Scroll pozisyonunu geri yükle
  useEffect(() => {
    if (containerRef.current) {
      const scrollKey = `scroll_${window.location.pathname}`;
      const savedScrollTop = localStorage.getItem(scrollKey);

      if (savedScrollTop) {
        setTimeout(() => {
          if (containerRef.current) {
            containerRef.current.scrollTop = parseInt(savedScrollTop);
          }
        }, 100);
      }
    }
  }, [data]);

  const handleScroll = () => {
    if (!containerRef.current) return;

    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;

    // Scroll pozisyonunu localStorage'a kaydet
    const scrollKey = `scroll_${window.location.pathname}`;
    localStorage.setItem(scrollKey, scrollTop.toString());
    /*
        // Navbar görünürlüğünü kontrol et
        if (scrollTop > lastScrollTop && scrollTop > 100) {
          // Aşağı scroll - navbar'ı gizle
          setIsNavVisible(false);
        } else {
          // Yukarı scroll - navbar'ı göster
          setIsNavVisible(true);
        }
        */
    setLastScrollTop(scrollTop);
  };

  const providerPermissions = { "7777": "INNOVA_7777_GAMES_ACCESS", "habanero": "INNOVA_HABANERO_GAMES_ACCESS", "pgsoft": "INNOVA_PGSOFT_GAMES_ACCESS", "platipus": "INNOVA_PLATIPUS_GAMES_ACCESS", "pragmatic": "INNOVA_PRAGMATIC_GAMES_ACCESS", "micro-gaming": "INNOVA_MICRO-GAMING_GAMES_ACCESS", "iconic21-slots": "INNOVA_ICONIC21-SLOTS_GAMES_ACCESS", "caletagaming": "INNOVA_CALETAGAMING_GAMES_ACCESS", "mancala": "INNOVA_MANCALA_GAMES_ACCESS", "goldenrace": "INNOVA_GOLDENRACE_GAMES_ACCESS", "jetx": "INNOVA_JETX_GAMES_ACCESS", "hacksaw": "INNOVA_HACKSAW_GAMES_ACCESS", "gamzix": "INNOVA_GAMZIX_GAMES_ACCESS", "evolutionGHX": "INNOVA_EVOLUTIONGHX_GAMES_ACCESS", "aviatrix": "INNOVA_AVIATRIX_GAMES_ACCESS", "turbo-games": "INNOVA_TURBO-GAMES_GAMES_ACCESS", "pascalgaming": "INNOVA_PASCALGAMING_GAMES_ACCESS", "popiplay": "INNOVA_POPIPLAY_GAMES_ACCESS", "galaxsysP": "INNOVA_GALAXSYSP_GAMES_ACCESS", "altente": "INNOVA_ALTENTE_GAMES_ACCESS", "wazdan-a": "INNOVA_WAZDAN-A_GAMES_ACCESS", "evolutionGH": "INNOVA_EVOLUTIONGH_GAMES_ACCESS", "popok": "INNOVA_POPOK_GAMES_ACCESS", "smartsoft": "INNOVA_SMARTSOFT_GAMES_ACCESS", "onetouch": "INNOVA_ONETOUCH_GAMES_ACCESS", "bitblox": "INNOVA_BITBLOX_GAMES_ACCESS", "clawbuster": "INNOVA_CLAWBUSTER_GAMES_ACCESS", "macaw": "INNOVA_MACAW_GAMES_ACCESS", "yoriginal-games": "INNOVA_YORIGINAL-GAMES_GAMES_ACCESS", "phoenix7": "INNOVA_PHOENIX7_GAMES_ACCESS", "booming": "INNOVA_BOOMING_GAMES_ACCESS", "abracadabra": "INNOVA_ABRACADABRA_GAMES_ACCESS", "beon": "INNOVA_BEON_GAMES_ACCESS", "adlunam": "INNOVA_ADLUNAM_GAMES_ACCESS", "ezugiZ": "INNOVA_EZUGIZ_GAMES_ACCESS", "eagaming": "INNOVA_EAGAMING_GAMES_ACCESS", "galaxsys": "INNOVA_GALAXSYS_GAMES_ACCESS", "betsoft-a": "INNOVA_BETSOFT-A_GAMES_ACCESS", "elagames-a": "INNOVA_ELAGAMES-A_GAMES_ACCESS", "in-out": "INNOVA_IN-OUT_GAMES_ACCESS", "rocketman": "INNOVA_ROCKETMAN_GAMES_ACCESS", "pigaboom": "INNOVA_PIGABOOM_GAMES_ACCESS", "netgame": "INNOVA_NETGAME_GAMES_ACCESS", "livegames": "INNOVA_LIVEGAMES_GAMES_ACCESS", "bigpot": "INNOVA_BIGPOT_GAMES_ACCESS", "dreamplay": "INNOVA_DREAMPLAY_GAMES_ACCESS", "iconic21": "INNOVA_ICONIC21_GAMES_ACCESS", "pragmatic-live": "INNOVA_PRAGMATIC-LIVE_GAMES_ACCESS", "pixmove-games": "INNOVA_PIXMOVE-GAMES_GAMES_ACCESS", "aviator": "INNOVA_AVIATOR_GAMES_ACCESS", "evoplay": "INNOVA_EVOPLAY_GAMES_ACCESS", "creedroomz": "INNOVA_CREEDROOMZ_GAMES_ACCESS", "creedroomzP": "INNOVA_CREEDROOMZP_GAMES_ACCESS", "bgaming": "INNOVA_BGAMING_GAMES_ACCESS", "ezugi": "INNOVA_EZUGI_GAMES_ACCESS", "kagaming": "INNOVA_KAGAMING_GAMES_ACCESS", "1x2gaming": "INNOVA_1X2GAMING_GAMES_ACCESS", "airdice": "INNOVA_AIRDICE_GAMES_ACCESS", "100hp": "INNOVA_100HP_GAMES_ACCESS", "only-play": "INNOVA_ONLY-PLAY_GAMES_ACCESS", "sagaming": "INNOVA_SAGAMING_GAMES_ACCESS", "spribe": "INNOVA_SPRIBE_GAMES_ACCESS", "tada": "INNOVA_TADA_GAMES_ACCESS", "barbara-bang": "INNOVA_BARBARA-BANG_GAMES_ACCESS" }

  return (
    <Translation>
      {(t) => (
        <div>
          <div
            style={{
              overflowY: "auto",
              height: 'calc(100dvh - 100px)',
              maxHeight: 'calc(100dvh - 100px)',
              WebkitOverflowScrolling: "touch",
              paddingBottom: "calc(120px + env(safe-area-inset-bottom))"
            }}
            ref={containerRef}
            onScroll={handleScroll}
            className="pb-[20px] "

            onLoad={adjustHeight}
          >

            <BannerCarouselV3 banners={banners} />

            {/*
              <section className=" py-2 mobile-show ">
              <ProvidersMobileSwiper _data={[...GameProviders]} />
            </section>

            <section className="py-2 mobile-hide">
              <ProvidersSwiper _data={[...GameProviders]} />
            </section>

                 <section className="mb-1">
              <FilterTypes />
            </section>

            */}

            <section className="mb-1">
              <FilterTypes
                FilterSearchValue={FilterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
                setProvider={setProvider}
                selectedProviders={selectedProviders}
                setSelectedProviders={setSelectedProviders}
                games={games}
                onFilterButtonsChange={setActiveFilterButton}
              />
            </section>


            {/* Oyun Listesi veya Boş Durum */}

            <div className={`px-1 pt-4 grid ${activeFilterButton === 2
              ? 'grid-cols-3'
              : 'grid-cols-2'
              } sm:grid-cols-4 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-2 md:gap-4`}>
              {data && [...((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) ? data : data.filter(x => {
                if (x._midleware == 'gasea') {
                  const _pk = createPermissionKey((x._midleware == 'innova' || x._midleware == 'gasea') ? x.vendor : x.provider_title, x._midleware, "_GAMES_ACCESS");

                  return props.permissions?.[_pk]?.Value;

                } else {
                   return props.permissions?.[providerPermissions[x.vendor]]?.Value;
                }
              }))].filter(x => {

                let _fieldKey = x._midleware == 'innova' ? 'title' : x._midleware == 'matgame' ? 'name' : x._midleware == 'gasea' ? 'title' : 'gameName';

                const __XXX = x[_fieldKey]
                  ?.toLocaleLowerCase()
                  .includes(FilterSearchValue?.toLocaleLowerCase());
                return __XXX

              }).map((item, index) => {
                switch (item._midleware) {
                  case 'innova':
                    return (
                      <InnovaBox
                        key={index}
                        isLive={false}
                        index={index}
                        item={item}
                      />
                    )
                  case 'matgame':
                    return (
                      <MatGameBox
                        key={index}
                        isLive={false}
                        index={index}
                        item={item}
                      />
                    )
                  case 'gasea':
                    return (
                      <GaseaBox
                        key={item.id}
                        isLive={false}
                        index={index}
                        item={item}
                        vendor={item._midleware}
                      />
                    )
                  default:
                    return <></>;
                }
              })}
            </div>
            {(!data || data.length == 0) && <NoGamesFound title={title} showRefreshButton={false} />}



            <Footer />
          </div>


          <BottomNavigation
            //     permissions={props.permissions}
            isNavVisible={isNavVisible}
          />
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions, permissionsAll } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    permissions,
    permissionsAll,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    UpdateSport: (data) => dispatch(gameAction.UpdateSportsData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollableListView);

export const GetGamePoster = (cat, data) => {
  switch (cat) {
    case "pragmatic-casino":
      return `https://common-static.ppgames.net/game_pic/square/200/${data.gameID}.png`;
    case "smartsoft":
      return `https://maxbetone.s3.eu-central-1.amazonaws.com/images/smartsoft/${data.GameName}.png`.toLowerCase();
    default:
      break;
  }
};

const banners = [
  {
    id: 1,
    img: require('../../../assets/img/home/slots.png'),
    gradient: "from-blue-600 to-blue-800",
    path: "/casino"
  },
  {
    id: 2,
    img: require('../../../assets/img/home/livecasino.png'),

    gradient: "from-secondary-600 to-secondary-800",
    path: "/live-casino"
  },
  {
    id: 3,
    img: require('../../../assets/img/home/womensports.png'),

    gradient: "from-green-600 to-green-800",
    path: "/"
  },
  {
    id: 4,
    img: require('../../../assets/img/home/jackpot1.png'),

    gradient: "from-purple-600 to-purple-800",
    path: "/my-account/"
  }
];
